import React, { useRef, useState } from "react";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { Password } from "primereact/password";
import { useHistory, useLocation } from "react-router-dom";
import { LOGIN_ROUTE_PATH } from "../app_utils/route_paths/resolver/PageRoutes";
import { BaseApiServiceImpl } from "../app_utils/api/BaseApiServiceImpl";
import { MessageUtils } from "../app_utils/utils/MessageUtils";
import { Messages } from "primereact/messages";

const ResetPassword = () => {
  const [emailAddress, setEmailAddress] = useState<string>("");
  const [otp, setOtp] = useState<string>("");
  const [newPassword, setNewPassword] = useState<string>("");
  const [confirmPassword, setConfirmPassword] = useState<string>("");
  const [isSaving, setIsSaving] = useState<boolean>(false);
  const [isReset, setIsReset] = useState<boolean>(false);
  const history = useHistory();
  const location = useLocation();
  const message = useRef<any>();

  React.useEffect(() => {
    const params = new URLSearchParams(location.search);
    const email = params.get("email");
    if (email) {
      setEmailAddress(email);
    }
  }, [location]);

  const goToLogin = () => {
    history.replace(LOGIN_ROUTE_PATH);
  };

  const validateForm = () => {
    if (!emailAddress.trim()) {
      MessageUtils.showErrorMessage(message, "Email address is required");
      return false;
    }
    if (!otp.trim()) {
      MessageUtils.showErrorMessage(message, "OTP is required");
      return false;
    }
    if (!newPassword) {
      MessageUtils.showErrorMessage(message, "New password is required");
      return false;
    }
    if (newPassword.length < 6) {
      MessageUtils.showErrorMessage(message, "Password must be at least 6 characters");
      return false;
    }
    if (newPassword !== confirmPassword) {
      MessageUtils.showErrorMessage(message, "Passwords do not match");
      return false;
    }
    return true;
  };

  const submitReset = () => {
    if (!validateForm()) return;

    setIsSaving(true);
    new BaseApiServiceImpl("/api/v1/auth/reset-password")
      .postRequestWithJsonResponse({
        emailAddress: emailAddress,
        otp: otp,
        newPassword: newPassword,
        confirmPassword: confirmPassword,
      })
      .then(async (response) => {
        setIsSaving(false);
        setIsReset(true);
      })
      .catch((error) => {
        setIsSaving(false);
        MessageUtils.showErrorMessage(message, error.message);
      });
  };

  if (isReset) {
    return (
      <div
        className="login-page flex flex-column"
        style={{
          background: "linear-gradient(to right, #4b79a1, #283e51)",
          height: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <div
          className="login-panel card shadow-lg p-4 rounded-lg"
          style={{ maxWidth: "450px", width: "100%" }}
        >
          <div className="text-center mb-4">
            <i className="pi pi-check-circle" style={{ fontSize: "4rem", color: "#22c55e" }}></i>
            <h2 style={{ color: "#283e51", marginTop: "1rem" }}>Password Reset Successful!</h2>
            <p className="text-muted">
              Your password has been reset successfully. You can now login with your new password.
            </p>
          </div>
          <Button
            className="p-button-rounded p-button-primary w-full mt-3"
            label="GO TO LOGIN"
            onClick={goToLogin}
            style={{
              backgroundColor: "#4b79a1",
              border: "none",
              width: "100%",
              fontSize: "1.1rem",
              padding: "0.75rem",
            }}
          />
        </div>
      </div>
    );
  }

  return (
    <div
      className="login-page flex flex-column"
      style={{
        background: "linear-gradient(to right, #4b79a1, #283e51)",
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "2rem 0",
      }}
    >
      <div
        className="login-panel card shadow-lg p-4 rounded-lg"
        style={{ maxWidth: "450px", width: "100%" }}
      >
        <div className="text-center mb-4">
          <h2 style={{ color: "#283e51" }}>Reset Password</h2>
          <p className="text-muted">
            Enter the OTP sent to your email and your new password.
          </p>
        </div>

        <Messages ref={message} style={{ width: "100%" }} />

        <div className="p-inputgroup mt-3">
          <span className="p-inputgroup-addon">
            <i className="pi pi-envelope"></i>
          </span>
          <InputText
            type="email"
            value={emailAddress}
            onChange={(e) => setEmailAddress(e.target.value)}
            placeholder="Email address"
            style={{ width: "100%" }}
          />
        </div>

        <div className="p-inputgroup mt-3">
          <span className="p-inputgroup-addon">
            <i className="pi pi-key"></i>
          </span>
          <InputText
            value={otp}
            onChange={(e) => setOtp(e.target.value)}
            placeholder="Enter OTP from email"
            style={{ width: "100%" }}
          />
        </div>

        <div className="mt-3">
          <label htmlFor="newPassword" className="block mb-2">New Password</label>
          <Password
            id="newPassword"
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
            placeholder="Enter new password"
            toggleMask
            feedback={true}
            style={{ width: "100%" }}
            inputStyle={{ width: "100%" }}
          />
        </div>

        <div className="mt-3">
          <label htmlFor="confirmPassword" className="block mb-2">Confirm Password</label>
          <Password
            id="confirmPassword"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            placeholder="Confirm new password"
            toggleMask
            feedback={false}
            style={{ width: "100%" }}
            inputStyle={{ width: "100%" }}
          />
        </div>

        <Button
          loading={isSaving}
          className="p-button-rounded p-button-primary w-full mb-3 mt-3"
          label="RESET PASSWORD"
          onClick={submitReset}
          style={{
            backgroundColor: "#4b79a1",
            border: "none",
            width: "100%",
            fontSize: "1.1rem",
            padding: "0.75rem",
          }}
        />

        <div className="text-center mt-3">
          <p className="text-muted">
            Remember your password?{" "}
            <a
              href="#"
              onClick={(e) => {
                e.preventDefault();
                goToLogin();
              }}
              style={{ color: "#4b79a1", fontWeight: "bold" }}
            >
              Login
            </a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;
